module.exports = __webpack_public_path__ + "images/cf23c086f127019f67713a96458ac9c4.png";